/**
 * Returns true if the value is `null` or `undefined`
 *
 * @param val - The val
 * @returns boolean
 */
export function isNullOrUndefined(val: any): val is null | undefined {
    return val === null || typeof val === 'undefined';
}
